import { Injectable } from '@angular/core';
import { isNotUndefined, Product, ProductScope, ProductService, RoutingService } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { distinctUntilChanged, filter, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomCurrentProductService extends CurrentProductService {
  constructor(
    private _routingService: RoutingService,
    private _productService: ProductService,
  ) {
    super(_routingService, _productService);
  }

  override getProduct(scopes?: (ProductScope | string)[] | ProductScope | string): Observable<Product | null> {
    return this.getCode().pipe(
      distinctUntilChanged(),
      switchMap((productCode: string) => {
        return productCode ? this._productService.get(productCode, scopes || this.DEFAULT_PRODUCT_SCOPE) : of(null);
      }),
      filter(isNotUndefined),
      map(product => {
        const mockAttrs: Product = {
          // customClassifications: {
          //   loadCurve: loadCurveClassificationMock,
          //   speedCurve: speedCurveClassificationMock,
          // },
          // efficiency: efficiencyMock,
        };

        return {
          ...product,
          ...mockAttrs,
        };
      }),
    );
  }
}
